import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
  timeout: 60000,
});

export const projectsApi = {
  list: (type) => api.get("/projects", { params: type ? { type } : {} }).then((r) => r.data),
  create: (data) => api.post("/projects", data).then((r) => r.data),
  update: (id, data) => api.patch(`/projects/${id}`, data).then((r) => r.data),
  remove: (id) => api.delete(`/projects/${id}`).then((r) => r.data),
};

export const dashboardApi = {
  stats: () => api.get("/dashboard/stats").then((r) => r.data),
};

export const aiApi = {
  chat: (payload) => api.post("/ai/chat", payload).then((r) => r.data),
  history: (sessionId) => api.get(`/ai/chat/${sessionId}`).then((r) => r.data),
  generate: (payload) => api.post("/ai/generate", payload).then((r) => r.data),
  routes: () => api.get("/ai/routes").then((r) => r.data),
  setRoute: (lab, payload) => api.put(`/ai/routes/${lab}`, payload).then((r) => r.data),
};
